import script from "./Card.vue?vue&type=script&lang=ts&setup=true"
export * from "./Card.vue?vue&type=script&lang=ts&setup=true"

import "./Card.vue?vue&type=style&index=0&id=48e9adcf&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e9adcf"]])

export default __exports__